const AutoTestResultStatusConstants = {
  NOT_STARTED: 0,
  RUNNING: 1,
  FINISHED: 2,
}

export default AutoTestResultStatusConstants
